"use client";

import { useSidebar } from "@/components/ui/sidebar";
import type { NavGroup } from "./eventNavConfig";
import { SidebarNavItem } from "./SidebarNavItem";

interface SidebarNavGroupProps {
  group: NavGroup;
}

export function SidebarNavGroup({ group }: SidebarNavGroupProps) {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  return (
    <div className="flex w-full flex-col gap-2">
      {!isCollapsed && group.title && (
        <p className="label-xs px-1 py-1 text-text-tertiary uppercase tracking-wider">
          {group.title}
        </p>
      )}
      {group.items.map((item) => (
        <SidebarNavItem key={item.href} item={item} />
      ))}
    </div>
  );
}
